export interface ApplyFormModel {
   first_name: string;
   last_name: string;
   email: string;
   phone_number: string | null;
   address: any;
   motivation: string;
   date_of_birth: any;
   cv: File | null;
   photo: File | null;
}

export function defaultApplyForm(): ApplyFormModel {
   return {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: null,
      address: null,
      motivation: '',
      date_of_birth: null,
      cv: null,
      photo: null,
   };
}
